import type { PapelUsuario } from '@pgcustom/shared-types';

export interface PermissoesEnvios {
  ler: boolean;
  atualizar: boolean;
}

/**
 * Espelho, no frontend, do grant real de RBAC do recurso `envios`
 * (`apps/api/src/modules/envios/envios.routes.ts`, seed original da
 * migration `004`): só `admin` (curinga `*`) tem qualquer permissão —
 * nenhum outro papel foi seedado para este recurso.
 */
export function permissoesEnvios(papel: PapelUsuario): PermissoesEnvios {
  if (papel === 'admin') return { ler: true, atualizar: true };
  return { ler: false, atualizar: false };
}
